import { motion } from "framer-motion";

const S = "/assets/screens";

const STEPS = [
  { step: "01", title: "Scan a visiting card", desc: "Open TOTO, point the camera and capture every detail instantly.", img: `${S}/home-dashboard.jpeg`, alt: "TOTO scan a card screen" },
  { step: "02", title: "Organize your connection", desc: "Details are sorted into categories and saved exactly where you need them.", img: `${S}/contact-details.jpeg`, alt: "TOTO contact details screen" },
  { step: "03", title: "Follow up and grow", desc: "Set reminders, hit daily goals and turn meetings into relationships.", img: `${S}/goals.jpeg`, alt: "TOTO networking goals screen" },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="bg-slate-50/70 py-16 sm:py-24" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-toto-blue" data-testid="how-it-works-eyebrow">How it works</span>
        <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="how-it-works-heading">
          Three steps to a smarter network
        </h2>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.step}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            className="rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            data-testid={`how-it-works-step-${s.step}`}
          >
            <span className="font-heading text-4xl font-bold text-toto-blue/15">{s.step}</span>
            <h3 className="mt-3 font-heading text-xl font-semibold text-slate-900">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
            <div className="mt-6 overflow-hidden rounded-2xl border-[6px] border-slate-900 shadow-lg">
              <img src={s.img} alt={s.alt} loading="lazy" className="h-52 w-full object-cover object-top" />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
